// src/Components/PrivateRoute/PrivateRoute.js
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getToken, isTokenValid, isPathAllowed, IsAuthenticated, getTokenIssuer } from "../../Utils/JWTTokenUtil";
import { BaseBox, BaseContainer, BaseBreadcrumbBar } from "../../Common/UI/exports";
import { TOP_BAR_HEIGHT } from "../../Common/UI/layoutConstants";
import BaseSidebar from "../../Common/UI/components/BaseSidebar";
import BaseHeader from "../../Common/UI/components/BaseHeader";
import BaseFooter from "../../Common/UI/components/BaseFooter";

const PrivateRoute = ({ element: Component }) => {
  const loc = useLocation();
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  if (getTokenIssuer() !== "ITAAP" && !IsAuthenticated()) {
    return <Navigate to="/" replace />;
  } else if (getTokenIssuer() === "ITAAP") {
    const token = getToken();
    if (!isTokenValid(token)) return <Navigate to="/" replace />;
  }

  if (!isPathAllowed(loc.pathname)) {
    return <Navigate to="/home" replace />;
  }

  return (
    <BaseBox sx={{ display: "flex", minHeight: "100vh", flexDirection: "column" }}>
      <BaseHeader onMenuClick={toggleSidebar} />
      <BaseBreadcrumbBar />
      <BaseBox sx={{ display: "flex", flex: 1, pt: `${TOP_BAR_HEIGHT}px` }}>
        <BaseSidebar items={[]} open={sidebarOpen} onToggle={toggleSidebar} />
        <BaseBox
          sx={{
            flex: 1,
            pt: 3,
            pb: 3,
            px: 2,
            backgroundColor: "#f9f9f9",
            transition: "margin-left 0.3s",
            ml: sidebarOpen ? "220px" : "50px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <BaseContainer maxWidth="lg" sx={{ pt: 2 }}>
            {Component}
          </BaseContainer>
        </BaseBox>
      </BaseBox>
      <BaseFooter />
    </BaseBox>
  );
};

export default PrivateRoute;
